window.onload = function () {
	// Check if Swiper is loaded and if we need a swiper
	if (!window.Swiper || !document.querySelector('.swiper-container')) {
		return;
	}

	var mySwiper = new Swiper ('.swiper-container', {
		loop: true,
		autoplay: {
			delay: 5000,
		},

		// Add pagination
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
	});

	var swiperContainer = document.querySelector('.swiper-container');

	// Add a class when the slider is sliding. This class is needed because
	// Chrome seems to have a bug where it shows a line of the neighbouring
	// slides outside the container despite overflow hidden.
	mySwiper.on('slideChangeTransitionStart', function() {
		swiperContainer.classList.add('sliding');
	});
	mySwiper.on('slideChangeTransitionEnd', function() {
		swiperContainer.classList.remove('sliding');
	});
};
